var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',[_c('oil-cap',{attrs:{"title":"ДОВЕРЕННОСТИ","buttons":[
      {
        route: 'coming-empowerment',
        name: 'Добавить Доверенность'
      }
    ],"items":_vm.empowerments}}),_c('v-divider',{staticClass:"my-2"}),_c('oil-table',{attrs:{"keys":[
      {
        text: 'Поставщик',
        value: 'SupplierName'
      },
      {
        text: 'ФИО',
        value: 'ContactPerson'
      },
      {
        text: 'Номер',
        value: 'Number'
      },
      {
        text: 'Количество',
        value: 'Amount'
      },
      {
        text: 'Статус',
        value: 'Status'
      }
    ],"items":_vm.empowerments,"paginate":_vm.count,"rowClick":_vm.handleRowClick},on:{"paginateAction":_vm.paginate}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }